
import { motion } from "framer-motion";
import Header from "@/components/Header";
import Footer from "@/components/Footer";
import { ArrowRight, CheckCircle, UserPlus, MousePointerClick, ExternalLink } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Link } from "react-router-dom";
import { HowItWorks as HowItWorksSection } from "@/components/sections/HowItWorks";
import { useIsMobile } from "@/hooks/use-mobile";
import ChatOption from "@/components/ChatOption";

const HowItWorks = () => {
  const isMobile = useIsMobile();
  return (
    <div className="min-h-screen bg-gradient-to-b from-corporate-primary-25 to-corporate-white">
      <Header />

      {/* Hero Section */}
      <section className="relative px-4 py-24 bg-gradient-to-r from-corporate-primary-100 to-corporate-primary-75 text-white">
        <div className="absolute inset-0 bg-[url('/lovable-uploads/8fd12166-0122-42a4-9da3-b430e2991c7a.png')] bg-center bg-no-repeat opacity-10"></div>
        <div className="max-w-4xl mx-auto text-center relative z-10">
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            className="flex items-center justify-center mb-4"
          >
            <div className="h-1 w-20 bg-corporate-secondary-100 mr-4"></div>
            <span className="text-corporate-secondary-75 font-semibold">HOW METRADE WORKS</span>
            <div className="h-1 w-20 bg-corporate-secondary-100 ml-4"></div>
          </motion.div>
          <motion.h1
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            className="text-4xl sm:text-5xl font-bold mb-6 leading-tight"
          >
            Take the Complexity Out of<br />Crypto Trading
          </motion.h1>
          <motion.p
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ delay: 0.1 }}
            className="text-xl opacity-90 max-w-2xl mx-auto"
          >
            METRADE simplifies crypto trading with our streamlined three-step process.
            Get started quickly and let expert-curated strategies do the hard work for you.
          </motion.p>
        </div>
        <div className="absolute bottom-0 left-0 right-0 h-16 bg-gradient-to-t from-white to-transparent"></div>
      </section>

      {/* How It Works Steps Section - maintain the component content but restyled */}
      <HowItWorksSection />

      {/* CTA Section */}
      <motion.section
        initial={{ opacity: 0, y: 20 }}
        whileInView={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.6 }}
        viewport={{ once: true }}
        className="px-4 py-16 mb-16"
      >
        <div className="text-center bg-gradient-to-r from-corporate-primary-100 to-corporate-primary-75 rounded-2xl p-8 md:p-12 max-w-4xl mx-auto shadow-lg relative overflow-hidden">
          <div className="absolute bottom-0 left-0 w-40 h-40 bg-corporate-secondary-100 rounded-full filter blur-3xl opacity-20 -mb-20 -ml-20"></div>
          <div className="absolute top-0 right-0 w-64 h-64 bg-corporate-secondary-75 rounded-full filter blur-3xl opacity-20 -mt-32 -mr-32"></div>
          <div className="relative z-10">
            <h2 className="text-2xl md:text-3xl font-bold text-corporate-white mb-4">
              Ready to Start Your Trading Journey?
            </h2>
            <p className="text-corporate-white/90 mb-8 text-lg max-w-2xl mx-auto">
              Join thousands of successful traders and let METRADE's automated strategies help you navigate the crypto market with confidence.
            </p>
            <Link to="/signup">
              <Button
                className="bg-corporate-secondary-100 hover:bg-corporate-secondary-75 text-corporate-primary-100 px-8 py-6 text-lg font-semibold rounded-lg shadow-lg hover:shadow-xl transition-all duration-300 transform hover:scale-105"
              >
                Get Started Now
                <ArrowRight className="ml-2 h-5 w-5" strokeWidth={2} />
              </Button>
            </Link>
          </div>
        </div>
      </motion.section>

      {/* Only show ChatOption on desktop */}
      {!isMobile && (
        <ChatOption />
      )}
      <Footer />
    </div>
  );
};

export default HowItWorks;
